import { Link } from "react-router-dom";
import { RiskBadge } from "./RiskMeter";
import { ArrowRight } from "@phosphor-icons/react";
import { formatINR } from "../lib/api";

export function BrandCard({ brand }) {
  const comingSoon = brand.status === "coming_soon";
  return (
    <div data-testid={`brand-card-${brand.slug}`}
      className="group card-franchise rounded-xl overflow-hidden flex flex-col transition-all duration-300 hover:-translate-y-1">
      <div className="relative h-40 overflow-hidden">
        <img src={brand.image} alt={brand.name} loading="lazy" className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" />
        <div className="absolute inset-0 bg-gradient-to-t from-navy-900 via-navy-900/30 to-transparent" />
        <span className="absolute top-3 left-3 eyebrow text-[0.6rem] bg-navy-950/70 px-2 py-1 rounded">{brand.category}</span>
        {comingSoon && <span className="absolute top-3 right-3 text-[0.6rem] uppercase tracking-widest bg-white/10 text-white px-2 py-1 rounded">Soon</span>}
      </div>
      <div className="p-5 flex flex-col gap-4 flex-1">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-display text-2xl text-white leading-none">{brand.name}</h3>
            <p className="text-xs text-ebg-muted mt-1.5">{brand.category}</p>
          </div>
          <RiskBadge level={brand.risk_level} />
        </div>
        <div className="grid grid-cols-2 gap-3 border-t border-white/10 pt-4">
          <div>
            <p className="text-[0.6rem] uppercase tracking-widest text-ebg-muted">Starting from</p>
            <p className="font-data text-white text-sm mt-1">{formatINR(brand.ticket_min)}</p>
          </div>
          <div>
            <p className="text-[0.6rem] uppercase tracking-widest text-ebg-muted">Indicative Payout Range*</p>
            <p className="font-data text-gold text-base mt-0.5">{brand.expected_roi}</p>
          </div>
        </div>
        <Link to={`/brands/${brand.slug}`} data-testid={`brand-view-${brand.slug}`}
          className="mt-auto inline-flex items-center justify-center gap-2 text-sm border border-gold/40 text-gold rounded-md py-2.5 hover:bg-gold/10 transition-colors group-hover:gap-3">
          View Details <ArrowRight size={15} />
        </Link>
      </div>
    </div>
  );
}
